import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { AuthServiceService } from '../../../../shareModule/services/auth-service.service';
import { ToastrService } from 'ngx-toastr';
import { Router } from '@angular/router';
import { LocalServiceService } from '../../../../shareModule/services/local-service.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../../../environments/environment';
import { CustomerService } from 'src/app/shareModule/services/customer.service';
import Swal from 'sweetalert2';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

@Component({
  selector: 'app-subadmin-cashback',
  templateUrl: './cashback.component.html',
  styleUrls: ['./cashback.component.scss'],
})
export class SubAdminCashbackComponent implements OnInit {
  @ViewChild('UploadFileModal') uploadFileModal: TemplateRef<any>;
  cashbacks: any;
  totalItems: number = 0;
  totalPages: number = 0;
  currentPage: number = 1;
  order_detail: any;
  imgUrl = environment.ImageUrl;
  cashbackValue: number = 0;
  
  payNowValue = "no"
  onPayNowChange(e, id){
    const target = e.target;
    const val = target.value;
    if(val == '1'){
      this.toastr.success("Payment sent!")
      this.local.confirmYesNo({title: 'Payment Email', text:"Should payment success email be sent?", icon: 'success'}).then(
        c =>{
          if(c.isConfirmed){
            this.auth.sendCashBackPaymentSuccessEmail(id).subscribe({
              next: (data)=>{
                this.toastr.success("Email sent")
                
              },
              error: (err)=>{
                console.error(err);
                this.toastr.error("Unable to message user!")
              }
            })

          }
        }
      )

    }
    
  }

  cashbackId: number | null = null;
  cashback: any = {
    appUserReferralHistories: [],
  };

  termsAndConditions: string = '';

  // Editor = ClassicEditor;
  EditorData: any = ``;
  EditorConfig = {
    toolbar: {
      items: [
        // 'heading',
        // '|',
        'bold',
        'italic',
        'link',
        '|',
        'bulletedList',
        'numberedList',
        '|',
        // 'insertTable',
        // 'imageUpload',
        // '|',
        'undo',
        'redo',
      ],
    },
  };

  constructor(
    private auth: AuthServiceService,
    private toastr: ToastrService,
    private router: Router,
    private local: LocalServiceService,
    private modalService: NgbModal,
    private customerService: CustomerService
  ) { }

  ngOnInit(): void {
    this.initData();
  }

  initData() {
    this.auth
      .shop_business_fetch({
        category: 'cashback',
        page: this.currentPage,
        limit: 12
      })
      .subscribe(
        (response: any) => {
          this.cashbacks = response.body.data;
          this.totalItems = response.body.totalItems;
          this.totalPages = response.body.totalPages;
          this.currentPage = response.body.currentPage;
        },
        (e) => {
          if (e.status == 400) {
            this.toastr.error(e.error.message);
          }
        }
      );
  }

  previousPage() {
    this.currentPage--;
    this.initData();
  }

  nextPage() {
    this.currentPage++;
    this.initData();
  }

  openModal(content: any) {
    this.modalService.open(content, {
      windowClass: 'upload_file_modal custom-width mt-5',
      // backdrop: 'static',
      keyboard: false,
      size: 'xs',
    });

    this.cashbackId = null;
    this.cashbackValue = 0;
    this.termsAndConditions = '';
  }

  imageView: string = ''
  openModalImage(content: any, image: string) {
    this.imageView = image
    this.modalService.open(content, {
      windowClass: 'upload_file_modal custom-width mt-5',
      // backdrop: 'static',
      keyboard: false,
      size: 'xs',
    });
  }

  handleEdit(data: any) {
    this.openModal(this.uploadFileModal);
    this.cashbackId = data.id;
    this.cashbackValue = data.discount;
    this.termsAndConditions = data.termsAndConditions;
  }

  onEditorChange = (event: any) =>
    (this.termsAndConditions = event.editor.getData());

  fileUpload: File | null = null;
  thumbnail: string | null = null;
  onFileSelected(event: any) {
    this.fileUpload = null;
    this.thumbnail = null;
    const file: File = event.target.files[0];
    if (file) {
      if (file.type.startsWith('image/')) {
        this.fileUpload = file;
        // const reader = new FileReader();
        // reader.onload = (e: any) => {
        //   console.log('Data URL:', e.target.result);
        // };
        this.toastr.success(`Selected image file: ${file.name}`);
      } else {
        this.toastr.warning('Please select an image file');
      }
    } else {
      this.toastr.warning('No file selected');
    }
  }

  isUploading: boolean = false;
  handleUpload() {
    if (this.fileUpload == null && !this.cashbackId) {
      this.toastr.warning('No file selected');
      return;
    }

    const payload = new FormData();

    if (this.cashbackId) {
      payload.append('id', this.cashbackId.toString());
    }

    if (this.fileUpload) {
      payload.append('file', this.fileUpload as Blob);
    }
    payload.append('category', 'cashback');
    payload.append('cashbackValue', this.cashbackValue.toString());
    payload.append('termsAndConditions', this.termsAndConditions);

    this.isUploading = true;

    this.auth.shop_business_store(payload).subscribe(
      (response: any) => {
        this.modalService.dismissAll();
        this.toastr.success('Uploaded successfully');
        this.isUploading = false;
        this.initData();
      },
      (e) => {
        this.toastr.error(e.error.message);
        this.isUploading = false;
      }
    );
  }

  handleDelete(id: any) {
    this.local
      .alertConfirm({
        message: 'Are you sure you want to delete this cashback?',
      })
      .then((res: any) => {
        if (res.isConfirmed) {
          this.auth.shop_business_delete(id).subscribe(
            (response: any) => {
              this.toastr.success('Deleted successfully');
              this.initData();
            },
            (e) => {
              this.toastr.error(e.error.message);
            }
          );
        }
      });
  }

  handleView(id: any) {
    this.auth.shop_business_view(id).subscribe(
      (response: any) => {
        this.toastr.success('Viewed successfully');
        this.cashback = response.body;
      },
      (e) => {
        this.toastr.error(e.error.message);
      }
    );
  }

  handleChangeStatus(id: any, event: any) {
    this.customerService
      .changeClaimStatus({ id, status: event.target.value })
      .subscribe(
        (response: any) => {
          this.toastr.success('Changed status successfully');
          this.initData();
        },
        (e) => {
          this.toastr.error(e.error.message);
        }
      );
  }
}
